import classNames from 'classnames'
import type { Dayjs } from 'dayjs'

import {
  buildMonthGrid,
  DATE_RANGE_FORMAT,
  type DateRangeValue,
  getCalendarDayState,
  WEEKDAY_NAMES,
} from '../../lib/dateRangeCalendar'
import cn from './DaysGrid.module.scss'

type DaysGridProps = {
  month: Dayjs
  value: Dayjs | null
  range: DateRangeValue
  today: Dayjs
  maxDate: Dayjs | null
  onSelect: (day: Dayjs) => void
}

function DaysGrid({
  month,
  value,
  range,
  today,
  maxDate,
  onSelect,
}: DaysGridProps) {
  return (
    <div className={cn.grid}>
      {WEEKDAY_NAMES.map((weekday) => (
        <span key={weekday} className={cn.weekday}>
          {weekday}
        </span>
      ))}
      {buildMonthGrid(month).map((day) => {
        const state = getCalendarDayState(day, {
          month,
          value,
          range,
          today,
          maxDate,
        })
        return (
          <button
            key={day.format('YYYY-MM-DD')}
            type="button"
            disabled={state.isDisabled}
            aria-pressed={state.isSelected}
            aria-label={day.format(DATE_RANGE_FORMAT)}
            className={classNames(
              cn.day,
              state.isOutside && cn.dayOutside,
              state.isToday && cn.dayToday,
              state.isInRange && cn.dayInRange,
              state.isRangeEdge && cn.dayRangeEdge,
              state.isSelected && cn.daySelected
            )}
            onClick={() => onSelect(day)}
          >
            {day.date()}
          </button>
        )
      })}
    </div>
  )
}

export default DaysGrid
